/** @format */

import { Col, Row } from "antd";
import responsiveColumn from "../../../methods/responsiveColumn";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { BoxComponent } from "./BoxComponent";

export interface PractiseAreaProps {
  id: number;
  title: string;
  description: string;
  href: string;
  learn_more: string;
  list: string;
}

export default function PracticeAreasSection() {
  const { t } = useTranslation("practice_groups_home_areas");
  const [openCard, setOpenCard] = useState<PractiseAreaProps | null>(null);

  const toggleDropdown = (openCardProps: PractiseAreaProps) => {
    if (openCardProps?.id === openCard?.id) {
      setOpenCard(null);
    } else {
      setOpenCard(openCardProps);
    }
  };

  const practiceGroups = t("practice_groupss", {
    returnObjects: true,
  }) as Array<any>;

  return (
    <Row style={{ paddingTop: 30, paddingBottom: 60 }} justify={"center"}>
      <Col {...responsiveColumn([16, 17, 18, 22, 22, 22])}>
        <Row gutter={[20, 20]}>
          <Col span={24} style={{ textAlign: "center" }}>
            <h3 className='section_title'>Our Practice Areas</h3>
            <div className='subtitle' style={{ marginBottom: 30 }}>
              We make it easy to get expert tax attorneys – no matter where you
              live.
            </div>
          </Col>
          {practiceGroups.map((area: any, index: number) => {
            return (
              <>
                <BoxComponent
                  id={area.id}
                  title={area.title}
                  description={area.description}
                  href={area.href}
                  learn_more={area.learn_more}
                  list={area.list}
                  isOpen={index === openCard?.id}
                  openCard={openCard}
                  toggleDropdown={toggleDropdown}
                />
              </>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
